import { C } from '../constants';
import { formatNumber, safePct } from '../utils';
import Glass from './Glass';

export default function DistrictBreakdown({ districtName, counts, isUserDistrict, stateData }) {
  const { parties, districts, localFont, strings, accent } = stateData;
  const district = districts.find(d => d.en === districtName);
  if (!district) return null;

  const dCounts = counts[districtName] || {};
  const total   = Object.values(dCounts).reduce((a, b) => a + b, 0);
  const sorted  = [...parties].sort((a, b) => (dCounts[b.id] || 0) - (dCounts[a.id] || 0));

  return (
    <Glass style={{ padding: '1.4rem' }}>
      <div className="flex items-baseline justify-between mb-4 flex-wrap gap-2">
        <div className="flex items-baseline gap-2 flex-wrap">
          <span style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: '1.5rem', color: C.white, letterSpacing: '-0.01em' }}>
            {district.en}
          </span>
          <span style={{ fontFamily: localFont, fontSize: '0.95rem', color: C.textDim }}>
            {district.local}
          </span>
          {isUserDistrict && (
            <span style={{
              fontSize: '0.58rem', letterSpacing: '0.16em', textTransform: 'uppercase',
              color: C.white, background: `linear-gradient(135deg, ${accent}, ${C.pink})`,
              padding: '3px 9px', fontWeight: 700, borderRadius: 999,
            }}>
              {strings.yourDistrict}
            </span>
          )}
        </div>
        <span style={{ fontWeight: 700, color: C.white, fontSize: '0.95rem' }}>
          {formatNumber(total)}{' '}
          <span style={{ color: C.textDim, fontWeight: 400, fontSize: '0.78rem' }}>votes</span>
        </span>
      </div>

      <div className="space-y-2">
        {sorted.map(p => {
          const v   = dCounts[p.id] || 0;
          const pct = safePct(v, total);
          return (
            <div key={p.id} className="flex items-center gap-3">
              <span style={{ width: 56, fontWeight: 700, fontSize: '0.85rem', color: C.white }}>{p.en}</span>
              <div className="flex-1">
                <div style={{ height: 6, backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: 3, overflow: 'hidden' }}>
                  <div style={{
                    height: '100%', width: `${pct}%`, backgroundColor: p.color,
                    borderRadius: 3, boxShadow: `0 0 8px ${p.color}AA`,
                    transition: 'width .6s cubic-bezier(.2,.7,.2,1)',
                  }} />
                </div>
              </div>
              <span style={{ width: 100, textAlign: 'right', fontSize: '0.76rem', color: C.textDim }}>
                <span style={{ color: C.white, fontWeight: 600 }}>{pct.toFixed(1)}%</span>
                {' · '}{formatNumber(v)}
              </span>
            </div>
          );
        })}
      </div>
    </Glass>
  );
}
